"use client"
import { get, post } from "@/app/helpers";
import Link from "next/link";
import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import useFetch from "@/app/useFetch";
import { useTheme } from "@/app/theme-provider";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { encryptRequest } from "@/app/helpers";
import PreviousComplaint from "./PreviousComplaint";

const FileComplaint = () => {
    const today = new Date().toISOString().split("T")[0];
    const { language } = useTheme();
    const [otpSlide, setotpSlide] = useState(1);
    const [fileComplaint, setFilecomplaint] = useState(false);
    const [districts, setdistricts] = useState([]);
    const [otp, setOtp] = useState("")
    const [show, setShow] = useState(false);
    const [submitResponse, setSubmitResponse] = useState(null);
    const [isdisable, setisdisable] = useState(false)
    const [department, setdepartment] = useState([])
    const [designation, setdesignation] = useState([])

    const [resendTimer, setResendTimer] = useState(30);
    const [canResend, setCanResend] = useState(false);
    const [resendKey, setResendKey] = useState(0);

    // const [previousComplaints, setPreviousComplaints] = useState([]);
    const [loadingComplaints, setLoadingComplaints] = useState(false);

    const [previousComplaintsData, setPreviousComplaintsdata] = useState([]);


    useEffect(() => {
        if (otpSlide !== 2) return;

        setResendTimer(30);
        setCanResend(false);

        const interval = setInterval(() => {
            setResendTimer((prev) => {
                if (prev === 1) {
                    clearInterval(interval);
                    setCanResend(true); // ✅ update only once
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [otpSlide, resendKey]);




    const handleResendOtp = () => {

        // call resend OTP API here
        handleVerify(); // or your resend API

        setResendTimer(30);
        setResendKey((prev) => prev + 1);
    };


    const handleClose = () => {
        setFilecomplaint(false)
        setotpSlide(1)
        setOtp("")
        setShow(false)
        setSubmitResponse(null)
    }
    const handleShow = () => setShow(true);


    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        fullname: "",
        email: "",
        phone: "",
        district: "",
        pincode: "",
        address: "",
        accused: "",
        designation: "",
        department: "",
        place: "",
        date_incident_from: "",
        date_incident_to: "",
        description: "",
        id_card_type: "",
        id_card_number: "",
        suspects: [
            { name: "", designation: "", department: "", office_name: "", office_address: "", district: "", other_information: "" }
        ]
    });

    const [files, setFiles] = useState([]);
    const [agree, setAgree] = useState(false);
    const fileInputRef = useRef(null);

    const { data: categories } = useFetch(
        "website/file-a-complaint-categories",
        []
    );



    // Input change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));

        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // File selection
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files).slice(0, 3);
        setFiles(selectedFiles);
    };

    const handleButtonClick = () => fileInputRef.current.click();

    // VALIDATION (NO DESIGN CHANGE)
    const validateForm = () => {
        const newErrors = {};

        const {
            fullname,
            phone,
            district,
            pincode,
            address,
            place,
            date_incident_from,
            date_incident_to,
            description,
            id_card_type,
            id_card_number
        } = formData;

        const required = {
            fullname,
            phone,
            district,
            pincode,
            address,
            place,
            date_incident_from,
            description,
            id_card_type,
            id_card_number
        };

        // required fields
        Object.keys(required).forEach((key) => {
            if (!required[key] || required[key].trim() === "") {
                newErrors[key] = `Please enter ${key.replace(/_/g, " ")}`;
            }
        });

        // Phone
        const phoneRegex = /^(\+91[\s-]?)?[0]?[6-9]\d{9}$/;
        if (phone && !phoneRegex.test(phone.trim())) {
            newErrors.phone = "Please enter a valid phone number";
        }

        // Pincode
        const pinRegex = /^[1-9][0-9]{5}$/;
        if (pincode && !pinRegex.test(pincode)) {
            newErrors.pincode = "Please enter a valid 6-digit pincode";
        }

        // Date validation
        if (date_incident_from && date_incident_to) {
            if (new Date(date_incident_from) > new Date(date_incident_to)) {
                newErrors.date_incident_to =
                    "Incident 'To' date cannot be earlier than 'From' date";
            }
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };



    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     // prevent double submit
    //     if (isdisable) return;

    //     setisdisable(true);

    //     if (!validateForm()) {
    //         setisdisable(false);
    //         return;
    //     }

    //     if (!agree) {
    //         toast.error("You must agree to the declaration before submitting.");
    //         setisdisable(false);
    //         return;
    //     }

    //     const submitData = new FormData();

    //     for (const key in formData) {
    //         submitData.append(key, formData[key] ?? "");
    //     }

    //     files.forEach((file) => {
    //         submitData.append("files[]", file);
    //     });

    //     try {
    //         const res = await post("website/file-a-complaint-submit", submitData);

    //         setSubmitResponse(res);
    //         setShow(true);
    //         toast.success("Complaint submitted successfully!");

    //         // Reset form
    //         setFormData({
    //             fullname: "",
    //             email: "",
    //             phone: "+91 ",
    //             district: "",
    //             pincode: "",
    //             address: "",
    //             accused: "",
    //             category: "",
    //             designation: "",
    //             department: "",
    //             place: "",
    //             date_incident: "",
    //             description: "",
    //             id_card_type: "",
    //             id_card_number: ""
    //         });

    //         setFiles([]);
    //         setAgree(false);
    //         setErrors({});

    //     } catch (err) {
    //         toast.error(
    //             err?.message || "Failed to submit complaint."
    //         );
    //     } finally {
    //         setisdisable(false);
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (isdisable) return;
        setisdisable(true);


        if (!validateForm()) {
            setisdisable(false);
            return;
        }

        if (!agree) {
            toast.error("You must agree to the declaration before submitting.");
            setisdisable(false);
            return;
        }


        const submitData = new FormData();

        for (const key in formData) {
            if (key === "suspects") {
                submitData.append("suspects", JSON.stringify(formData.suspects));
            } else {
                submitData.append(key, formData[key] ?? "");
            }
        }

        if (files && files.length > 0) {
            files.forEach((file) => {
                submitData.append("files[]", file);
            });
        }

        try {

            const res = await post("website/file-a-complaint-submit", submitData);

            setSubmitResponse(res);
            setShow(true);
            toast.success("Complaint submitted successfully!");


            setFormData({
                fullname: "",
                email: "",
                phone: "+91 ",
                district: "",
                pincode: "",
                address: "",
                accused: "",
                category: "",
                designation: "",
                department: "",
                place: "",
                date_incident_from: "",
                date_incident_to: "",
                description: "",
                id_card_type: "",
                id_card_number: "",

                suspects: [
                    {
                        name: "",
                        designation: "",
                        department: "",
                        office_name: "",
                        office_address: "",
                        district: "",
                        other_information: "",
                    },
                ],
            });

            setFiles([]);
            setAgree(false);
            setErrors({});
            setShowError(false);
        } catch (err) {
            toast.error(
                err?.message || "Failed to submit complaint."
            );
        } finally {
            setisdisable(false);
        }
    };

    async function handleVerify() {
        const isValid = /^(\+91[\s-]?)?[0]?[6-9]\d{9}$/.test(formData.phone);

        if (!isValid) {
            toast.error("Please enter a valid phone number");
            return;
        }

        try {
            // Step 1: Convert form values to object
            const dataObj = {
                phone: formData.phone,
            };

            // Step 2: Encrypt the object
            const encryptedPayload = encryptRequest(dataObj);

            // Step 3: Send encrypted data inside FormData
            const fd = new FormData();
            fd.append("payload", encryptedPayload);

            await post("website/file-a-complaint-otp", fd);

            toast.success("OTP sent successfully");
            setotpSlide(2); // move to OTP screen only after API success

        } catch (err) {
            toast.error(err?.message || "Failed to send OTP. Please try again.");
        }
    }

    useEffect(() => {
        get("website/districts").then((res) => setdistricts(res));
        get("website/departments").then((res) => setdepartment(res))
        get("website/designations").then((res) => setdesignation(res))
    }, [fileComplaint]);




    function maskPhoneNumber(phone = "") {
        if (!phone) return "";
        const visibleStart = phone.slice(0, 2);
        const visibleEnd = phone.slice(-2);
        const masked = "*".repeat(phone.length - 4);
        return `${visibleStart}${masked}${visibleEnd}`;
    }



    async function handleotpInput() {
        const otpRegex = /^[0-9]{6}$/;

        if (!otpRegex.test(otp)) {
            toast.error("Please enter a valid 6 digit OTP");
            return;
        }

        try {

            const dataObj = {
                phone: formData.phone,
                otp: otp,
            };

            const encryptedPayload = encryptRequest(dataObj);


            const fd = new FormData();
            fd.append("payload", encryptedPayload);

            await post("website/file-a-complaint-validate", fd);

            toast.success("OTP verified successfully");
            setFilecomplaint(true);
            fetchPreviousComplaints()

        } catch (err) {
            toast.error(err?.message || "Invalid OTP. Please try again.");
        }
    }

    const handleSuspectChange = (index, e) => {
        if (showError) {
            setShowError(false);
        }
        const { name, value } = e.target;
        const updatedSuspects = [...formData.suspects];
        updatedSuspects[index][name] = value;
        setFormData({ ...formData, suspects: updatedSuspects });
    };


    const addSuspect = () => {
        setFormData({
            ...formData,
            suspects: [
                ...formData.suspects,
                { name: "", designation: "", department: "", office_name: "", office_address: "", district: "", other_information: "" }
            ]
        });
    };


    const removeSuspect = (index) => {
        const updatedSuspects = formData.suspects.filter((_, i) => i !== index);
        setFormData({ ...formData, suspects: updatedSuspects });
    };

    const [showError, setShowError] = useState(false);

    const hasUserStartedFilling = () => {
        const lastSuspect = formData?.suspects[formData.suspects.length - 1];
        if (!lastSuspect) return false;


        return Object.values(lastSuspect).some(value => value && value.toString().trim() !== "");
    };

    const handleAddSuspectClick = () => {
        if (hasUserStartedFilling()) {
            addSuspect();
            setShowError(false);
        } else {
            setShowError(true);
        }
    };



    async function fetchPreviousComplaints() {
        try {
            setLoadingComplaints(true);
            const res = await post("/website/file-a-complaint-past-data", { phone: formData.phone });
            setPreviousComplaintsdata(res?.data || []);
        } catch (err) {
            toast.error("Unable to load previous complaints");
        } finally {
            setLoadingComplaints(false);
        }
    }







    return (
        <section className="mt-5" data-lenis-prevent>
            <Modal centered show={show} >
                <Modal.Header >
                    <Modal.Title className="text-success">
                        Complaint Submitted Successfully
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    {/* Success icon */}
                    <div className="mb-3">
                        <i
                            className="bi bi-check-circle-fill"
                            style={{ fontSize: "3rem", color: "#198754" }}
                        ></i>
                    </div>

                    <p className="mb-2">
                        Your complaint has been submitted successfully.
                    </p>

                    <p className="fw-semibold mb-1">
                        Acknowledgement Number
                    </p>

                    {/* Acknowledgement number box */}
                    <div
                        className="d-flex align-items-center justify-content-center gap-2 border rounded p-2"
                        style={{ background: "#f8f9fa" }}
                    >
                        <span className="fw-bold text-primary">
                            {submitResponse?.complaint_id}
                        </span>

                        <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => {
                                navigator.clipboard.writeText(submitResponse?.complaint_id);
                                toast.success("Acknowledgement number copied");
                            }}
                        >
                            Copy
                        </Button>
                    </div>

                    <p className="mt-3 text-muted small">
                        Please save this Tracking ID to check the status of your complaint
                    </p>
                </Modal.Body>

                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>


            {/* OTP SECTION (unchanged) */}
            {!fileComplaint ? (
                <>
                    <div className="row  mt-40">

                        <div className="col-lg-8 col-md-7">
                            <div className="filecomplaint-dec">
                                <h2 className="">{language == "en" ? "How to File a Complaint ?" : "പരാതി എങ്ങനെ ഫയൽ ചെയ്യാം?"}</h2>
                                <p className="mt-40">
                                    {language == "en" ? "The Vigilance & Anti-Corruption Bureau (VACB), Kerala, is committed to ensuring a corruption-free and transparent public service environment. If you are aware of any act of corruption, bribery, misuse of power, or other forms of misconduct involving public servants or government institutions, you can file a complaint directly with us." : "കേരളത്തിലെ വിജിലൻസ് & ആന്റി-കറപ്ഷൻ ബ്യൂറോ (VACB) അഴിമതി രഹിതവും സുതാര്യവുമായ പൊതു സേവന അന്തരീക്ഷം ഉറപ്പാക്കാൻ പ്രതിജ്ഞാബദ്ധമാണ്. പൊതുപ്രവർത്തകരോ സർക്കാർ സ്ഥാപനങ്ങളോ ഉൾപ്പെടുന്ന ഏതെങ്കിലും അഴിമതി, കൈക്കൂലി, അധികാര ദുർവിനിയോഗം അല്ലെങ്കിൽ മറ്റ് തരത്തിലുള്ള ദുഷ്‌പെരുമാറ്റം എന്നിവയെക്കുറിച്ച് നിങ്ങൾക്ക് അറിയാമെങ്കിൽ, നിങ്ങൾക്ക് നേരിട്ട് ഞങ്ങളിൽ പരാതി നൽകാം."}
                                </p>
                                <p>
                                    {language == "en" ? "Your identity will be kept confidential in accordance with legal provisions, and every genuine complaint will be examined carefully." : "നിയമപരമായ വ്യവസ്ഥകൾക്കനുസൃതമായി നിങ്ങളുടെ ഐഡന്റിറ്റി രഹസ്യമായി സൂക്ഷിക്കും, കൂടാതെ ഓരോ യഥാർത്ഥ പരാതിയും ശ്രദ്ധാപൂർവ്വം പരിശോധിക്കും."}
                                </p>
                                <ul className="custom-bullet-list">
                                    <li>
                                        <img src={"/icons/bluearrow.svg"} alt="bulet-img" className="bullet-img" />
                                        {language == "en" ? " Verify Your Phone Number" : "നിങ്ങളുടെ ഫോൺ നമ്പർ പരിശോധിക്കുക"}
                                    </li>
                                    <li>
                                        <img src={"/icons/bluearrow.svg"} alt="blue-arrow" className="bullet-img" />
                                        {language == "en" ? "Provide Your Personal Details" : "നിങ്ങളുടെ സ്വകാര്യ വിശദാംശങ്ങൾ നൽകുക"}
                                    </li>
                                    <li>
                                        <img src={"/icons/bluearrow.svg"} alt="blue-arrow" className="bullet-img" />
                                        {language == "en" ? "Describe the Incident in Detail" : "സംഭവം വിശദമായി വിവരിക്കുക"}
                                    </li>
                                    <li>
                                        <img src={"/icons/bluearrow.svg"} alt="blue-arrow" className="bullet-img" />
                                        {language == "en" ? "Attach Supporting Evidence (if available)" : "പിന്തുണയ്ക്കുന്ന തെളിവുകൾ അറ്റാച്ചുചെയ്യുക (ലഭ്യമെങ്കിൽ)"}
                                    </li>
                                    <li>
                                        <img src={"/icons/bluearrow.svg"} alt="blue-arrow" className="bullet-img" />
                                        {language == "en" ? "Review and Submit" : "അവലോകനം ചെയ്ത് സമർപ്പിക്കുക"}
                                    </li>
                                    {/* <li>
                                        <img src={"/icons/bluearrow.svg"} alt="blue-arrow" className="bullet-img" />
                                        {language == "en" ? "Review and Submit" : "അവലോകനം ചെയ്ത് സമർപ്പിക്കുക"}
                                    </li> */}
                                    <li>
                                        <img src={"/icons/bluearrow.svg"} alt="blue-arrow" className="bullet-img" />
                                        {language == "en"
                                            ? "Tracking details will be sent to your registered mobile number"
                                            : "ട്രാക്കിംഗ് വിശദാംശങ്ങൾ നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത മൊബൈൽ നമ്പറിലേക്ക് അയയ്ക്കുന്നതാണ്"}
                                    </li>


                                </ul>
                            </div>
                        </div>

                        {otpSlide == 1 ? (
                            <>
                                <div className="col-lg-4 col-md-5">
                                    <div className="filecomplaint-box">
                                        <img src="/icons/call.svg" alt="call" />
                                        <h5 className="mt-3 text-center">{language == "en" ? "Enter your 10 Digit Mobile number" : "നിങ്ങളുടെ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക"}</h5>
                                        <input
                                            type="number"
                                            className="form-control mt-3"
                                            placeholder="Enter mobile number"
                                            onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        <button onClick={handleVerify} className="w-100 mt-3">{language == "en" ? "Continue" : "തുടരുക"}</button>

                                        <Link style={{ color: "#ff4d00 " }} href="/complaint-status" className="mt-4">{language == "en" ? "Track Complaint Status" : "പരാതിയുടെ നില ട്രാക്ക് ചെയ്യുക"}</Link>
                                    </div>
                                </div>
                            </>
                        ) : otpSlide == 2 ? (
                            <>
                                <div className="col-lg-4 col-md-5">
                                    <div className="filecomplaint-box">
                                        <img src="/icons/call.svg" alt="call" />
                                        <h5 className="mt-3 text-center">{language == "en" ? "We have sent an OTP to" : "ഞങ്ങൾ ഒരു OTP അയച്ചു"}</h5>
                                        <p className="">{maskPhoneNumber(formData.phone)}</p>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter OTP"
                                            onChange={(e) => setOtp(e.target.value)}
                                            value={otp}

                                        />
                                        <button onClick={() => handleotpInput()} className="w-100 mt-3">Continue</button>
                                        <div className="text-center mt-3">
                                            {canResend ? (
                                                <button
                                                    type="button"
                                                    onClick={handleResendOtp}
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        color: "#ff4d00",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Resend OTP
                                                </button>
                                            ) : (
                                                <p style={{ fontSize: "14px" }}>
                                                    Resend OTP in {resendTimer}s
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : null}



                    </div>
                </>
            ) : (
                <>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-12 complaint-detail-box">
                                <div className="form-box p-4">
                                    <div className="row">
                                        <h5 className="form-title mb-4">Personal Details</h5>

                                        {/* FULL NAME */}
                                        <div className="col-md-4 mb-3">
                                            <label>Full Name *</label>
                                            <input
                                                name="fullname"
                                                type="text"
                                                className="form-control"
                                                value={formData.fullname}
                                                onChange={handleChange}
                                            />
                                            {errors.fullname && (
                                                <p className="text-danger small">{errors.fullname}</p>
                                            )}
                                        </div>

                                        {/* PHONE */}
                                        <div className="col-md-4 mb-3">
                                            <label>Phone *</label>
                                            <div className="position-relative">
                                                <input
                                                    name="phone"
                                                    type="text"
                                                    disabled
                                                    value={formData?.phone}
                                                    //  onChange={handleChange}
                                                    className="form-control"
                                                />
                                                <img className="phn-verify" src="/icons/tick.svg" alt="phone" />
                                            </div>
                                            {errors.phone && (
                                                <p className="text-danger small">{errors.phone}</p>
                                            )}
                                        </div>

                                        {/* EMAIL */}
                                        <div className="col-md-4 mb-3">
                                            <label>Email</label>
                                            <input
                                                name="email"
                                                type="text"
                                                className="form-control"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* ADDRESS */}
                                        <div className="col-md-4 mb-3">
                                            <label>Address *</label>
                                            <textarea
                                                name="address"
                                                className="form-control"
                                                value={formData.address}
                                                onChange={handleChange}
                                            />
                                            {errors.address && (
                                                <p className="text-danger small">{errors.address}</p>
                                            )}
                                        </div>

                                        {/* DISTRICT */}
                                        <div className="col-md-4 mb-3">
                                            <label>District *</label>
                                            <select
                                                className="form-control"
                                                name="district"
                                                value={formData.district}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select District</option>
                                                {districts.map((dis) => (
                                                    <option key={dis.value} value={dis.value}>
                                                        {dis.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.district && (
                                                <p className="text-danger small">{errors.district}</p>
                                            )}
                                        </div>

                                        {/* PINCODE */}
                                        <div className="col-md-4 mb-3">
                                            <label>Pincode *</label>
                                            <input
                                                name="pincode"
                                                type="text"
                                                className="form-control"
                                                value={formData.pincode}
                                                onChange={handleChange}
                                            />
                                            {errors.pincode && (
                                                <p className="text-danger small">{errors.pincode}</p>
                                            )}
                                        </div>


                                        {/* ID CARD TYPE */}
                                        <div className="col-md-4 mb-3">
                                            <label>ID Card Type *</label>
                                            <select
                                                className="form-control"
                                                name="id_card_type"
                                                value={formData.id_card_type}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value="voterid">Voter ID</option>
                                                <option value="aadhaar">Aadhaar Card</option>
                                                <option value="pan">PAN Card</option>
                                                <option value="passport">Passport</option>
                                                <option value="driving_license">Driving Licence</option>
                                                <option value="ration_card">Ration Card</option>
                                            </select>
                                            {errors.id_card_type && (
                                                <p className="text-danger small">{errors.id_card_type}</p>
                                            )}
                                        </div>

                                        {/* ID NUMBER */}
                                        <div className="col-md-4 mb-3">
                                            <label>ID Number *</label>
                                            <input
                                                name="id_card_number"
                                                type="text"
                                                className="form-control"
                                                value={formData.id_card_number}
                                                onChange={handleChange}
                                            />
                                            {errors.id_card_number && (
                                                <p className="text-danger small">{errors.id_card_number}</p>
                                            )}
                                        </div>

                                        <h5 className="form-title mt-3 mb-4">
                                            Complaint Details
                                        </h5>
                                        {/* <div className="row">
                                         <div className="col-md-4 mb-3">
                                            <label>Name of the Accused</label>
                                            <input
                                                name="accused"
                                                type="text"
                                                className="form-control"
                                                value={formData.accused}
                                                onChange={handleChange}
                                            />
                                        </div>

                                  
                                        <div className="col-md-4 mb-3">
                                            <label>Department</label>
                                            <select
                                                className="form-control"
                                            >
                                                <option value="">Select Department</option>
                                                {department?.map((item, index) => (
                                                    <>
                                                        <option value={item.value}>{item.label}</option>
                                                    </>
                                                ))}
                                            </select>
                                           
                                        </div>

                                   
                                        <div className="col-md-4 mb-3">
                                            <label>Designation</label>
                                            <select
                                                className="form-control"
                                            >
                                                <option value="">Select Designation</option>
                                                {designation?.map((item, index) => (
                                                    <>
                                                        <option value={item.value}>{item.label}</option>
                                                    </>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label>Office Name</label>
                                            <input
                                                name="office_name"
                                                type="text"
                                                className="form-control"
                                                // value={formData.id_card_number}
                                                onChange={handleChange}
                                            />
                                            {errors.id_card_number && (
                                                <p className="text-danger small">{errors.id_card_number}</p>
                                            )}
                                        </div>

                                         <div className="col-md-4 mb-3">
                                            <label>Office Address</label>
                                            <input
                                                name="office_address"
                                                type="text"
                                                className="form-control"
                                                // value={formData.id_card_number}
                                                onChange={handleChange}
                                            />
                                            {errors.id_card_number && (
                                                <p className="text-danger small">{errors.id_card_number}</p>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label>District *</label>
                                            <select
                                                className="form-control"
                                                name="district"
                                                value={formData.district}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select District</option>
                                                {districts.map((dis) => (
                                                    <option key={dis.value} value={dis.value}>
                                                        {dis.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.district && (
                                                <p className="text-danger small">{errors.district}</p>
                                            )}
                                        </div>

                                         <div className="col-md-4 mb-3">
                                            <label>Other Information *</label>
                                            <input
                                                name="other_information"
                                                type="text"
                                                className="form-control"
                                                value={formData?.other_information}
                                                onChange={handleChange}
                                            />
                                            {errors.date_incident_from && (
                                                <p className="text-danger small">{errors.date_incident_from}</p>
                                            )}
                                        </div>

                                       </div> */}
                                        {formData?.suspects?.map((suspect, index) => (
                                            <div key={index} className="row  ">
                                                <p>Suspect #{index + 1}</p>

                                                <div className="col-md-4 mb-3">
                                                    <label>Name of the Accused</label>
                                                    <input
                                                        name="name"
                                                        type="text"
                                                        className="form-control"
                                                        value={suspect?.name}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    />
                                                </div>


                                                <div className="col-md-4 mb-3">
                                                    <label>Department</label>
                                                    <select
                                                        name="department"
                                                        className="form-control"
                                                        value={suspect.department}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    >
                                                        <option value="">Select Department</option>
                                                        {department?.map((item) => (
                                                            <option key={item.value} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </div>


                                                <div className="col-md-4 mb-3">
                                                    <label>Designation</label>
                                                    <select
                                                        name="designation"
                                                        className="form-control"
                                                        value={suspect.designation}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    >
                                                        <option value="">Select Designation</option>
                                                        {designation?.map((item) => (
                                                            <option key={item.value} value={item.value}>{item.label}</option>
                                                        ))}
                                                    </select>
                                                </div>


                                                <div className="col-md-4 mb-3">
                                                    <label>Office Name</label>
                                                    <input
                                                        name="office_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={suspect.office_name}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label>Office Address</label>
                                                    <input
                                                        name="office_address"
                                                        type="text"
                                                        className="form-control"
                                                        value={suspect?.office_address}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    />
                                                </div>


                                                <div className="col-md-4 mb-3">
                                                    <label>District</label>
                                                    <select
                                                        name="district"
                                                        className="form-control"
                                                        value={suspect?.district}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    >
                                                        <option value="">Select District</option>
                                                        {districts?.map((dis) => (
                                                            <option key={dis?.value} value={dis?.value}>{dis?.label}</option>
                                                        ))}
                                                    </select>
                                                </div>


                                                <div className="col-md-4 mb-3">
                                                    <label>Other Information</label>
                                                    <input
                                                        name="other_information"
                                                        type="text"
                                                        className="form-control"
                                                        value={suspect?.other_information}
                                                        onChange={(e) => handleSuspectChange(index, e)}
                                                    />
                                                </div>

                                                {formData.suspects.length > 1 && (
                                                    <div className="col-12 mb-2">
                                                        <button style={{ backgroundColor: '#ec0707', color: 'white' }} type="button" className="btn submit-com-button btn-sm" onClick={() => removeSuspect(index)}>
                                                            Remove Suspect
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ))}


                                        <div className="row mb-4">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="button"
                                                    className="btn submit-com-button"
                                                    onClick={handleAddSuspectClick}
                                                >
                                                    + Add Another Suspect
                                                </button>

                                                {/* Error message in RED */}
                                                {showError && (
                                                    <div style={{ color: '#ec0707', fontSize: '14px', marginTop: '8px', fontWeight: '500' }}>
                                                        Please fill at least one field before adding another accused.
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* ACCUSED */}

                                        {/* ============================sspect2 */}

                                        {/* FROM DATE */}
                                        <div className="col-md-4 mb-3">
                                            <label>From Date of Incident *</label>
                                            <input
                                                name="date_incident_from"
                                                type="date"
                                                className="form-control"
                                                value={formData.date_incident_from}
                                                onChange={handleChange}
                                            />
                                            {errors.date_incident_from && (
                                                <p className="text-danger small">{errors.date_incident_from}</p>
                                            )}
                                        </div>

                                        {/* TO DATE */}
                                        <div className="col-md-4 mb-3">
                                            <label>To Date of Incident</label>
                                            <input
                                                name="date_incident_to"
                                                type="date"
                                                className="form-control"
                                                value={formData.date_incident_to}
                                                onChange={handleChange}
                                                max={today}
                                            />
                                            {errors.date_incident_to && (
                                                <p className="text-danger small">{errors.date_incident_to}</p>
                                            )}
                                        </div>

                                        {/* PLACE */}
                                        <div className="col-md-4 mb-3">
                                            <label>Place of Incident *</label>
                                            <input
                                                name="place"
                                                type="text"
                                                className="form-control"
                                                value={formData.place}
                                                onChange={handleChange}
                                            />
                                            {errors.place && (
                                                <p className="text-danger small">{errors.place}</p>
                                            )}
                                        </div>

                                        {/* DESCRIPTION */}
                                        <div className="col-md-12 mb-3">
                                            <label>Detailed Description *</label>
                                            <textarea
                                                name="description"
                                                className="form-control"
                                                rows="4"
                                                value={formData.description}
                                                onChange={handleChange}
                                            />
                                            {errors.description && (
                                                <p className="text-danger small">{errors.description}</p>
                                            )}
                                        </div>

                                        {/* FILE UPLOAD */}
                                        <div className="mb-3">
                                            <p className="evidance-p">Upload Evidence</p>

                                            <div className="com-file-div">
                                                <p className="file-com-p" style={{ fontStyle: "italic" }}>
                                                    (PDF, JPG, PNG, MP4, DOC 5MB per file, max 3 files)
                                                </p>

                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    className="d-none"
                                                    multiple
                                                    accept=".pdf,.jpg,.jpeg,.png,.mp4,.doc,.docx"
                                                    onChange={handleFileChange}
                                                />
                                                <button
                                                    type="button"
                                                    className="upload-com-button"
                                                    onClick={handleButtonClick}
                                                >
                                                    Upload file
                                                </button>
                                            </div>

                                            {files.length > 0 && (
                                                <ul className="mt-3 small">
                                                    {files.map((file, idx) => (
                                                        <li key={idx}>{file.name}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>

                                        {/* DECLARATION */}
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p className="evidance-text mb-0">
                                                    I hereby declare that the information provided in this
                                                    complaint is true.
                                                </p>
                                            </div>
                                        </div>

                                        {/* CHECKBOX + BUTTON */}
                                        <div className="row mt-4">
                                            <div className="col-md-6">
                                                <input
                                                    className="form-check-input custom-checkbox"
                                                    type="checkbox"
                                                    id="agree"
                                                    checked={agree}
                                                    onChange={(e) => setAgree(e.target.checked)}
                                                    style={{ accentColor: "#0d6efd" }}
                                                />
                                                <label
                                                    style={{ fontStyle: "italic" }}
                                                    className="form-check-label file-com-p mx-2"
                                                    htmlFor="agree"
                                                >
                                                    I agree to the above declaration.
                                                </label>
                                            </div>

                                            <div className="col-md-6 submit-btn-file">
                                                <button disabled={isdisable} type="submit" className="submit-com-button">
                                                    Submit Complaint
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            )}
            {previousComplaintsData?.length>0 && fileComplaint &&

                <PreviousComplaint previousComplaintsData={previousComplaintsData} />
            }


        </section>
    );
};

export default FileComplaint;
